<template>
  <div id="milestones" class="pos-rel" @click.stop.prevent>
    <div
      class="milestone-wrapper"
      :style="{ backgroundColor: isDarkTheme ? 'transparent' : '#ffffff' }"
    >
      <div
        class="align-hor center-ver pos-rel"
        style="display : flex;
    width: max-content;
    height: 47px;
    overflow-x: scroll;
    justify-content: flex-start;
    scrollbar-width: none;
    flex-direction: row;
    align-items: flex-end;
    "
        :class="[
          model.mile_stones.length >= 5 && windowWidth > 511
            ? 'start-hor'
            : 'center-hor'
        ]"
      >
        <div
          class="db-wrapper"
          v-for="(ms, i) in model.mile_stones"
          ref="milestones"
          :style="
            i == milestones.length - 1
              ? 'margin-right:5px; padding-right:16px'
              : ''
          "
        >
          <div>
            <div class="lined-bg align-ver center-hor" v-if="ms.is_checked">
              <div
                class="pos-rel align-hor center-ver center-hor"
                v-if="ms.won"
              >
                <img
                  class="w-17"
                  src="@/assets/medal.svg"
                  slot="reference"
                  @click.stop.prevent="emitMileStone(ms)"
                  data-toggle="modal"
                  data-target="#exampleModalCenter"
                />
              </div>
              <div
                class="radius50 bg-light padding-4 align-hor center-ver center-hor wh10"
                :style="{ background: topBgColor }"
                v-else
              >
                <div class="check-mark"></div>
              </div>
            </div>
            <div class="dotted-bg align-ver center-hor" v-else>
              <div
                class="pos-rel align-hor center-ver center-hor"
                v-if="ms.to_earn"
              >
                <img
                  v-if="ms.icon"
                  class="w-20"
                  :src="ms.icon"
                  slot="reference"
                  @click.stop.prevent="emitMileStone(ms)"
                  data-toggle="modal"
                  data-target="#exampleModalCenter"
                />
                <img
                  v-else
                  class="w-20"
                  src="@/assets/medal.svg"
                  slot="reference"
                  @click.stop.prevent="emitMileStone(ms)"
                  data-toggle="modal"
                  data-target="#exampleModalCenter"
                />
              </div>
              <div
                class="radius50 bg-light padding-4"
                style="border: 1px solid #6D6666"
                :style="{
                  backgroundColor: isDarkTheme ? 'transparent' : '#ffffff'
                }"
                v-else
              >
                <div
                  class="radius50 wh10"
                  :style="{ background: topBgColor }"
                ></div>
              </div>
            </div>
            <div
              :class="
                i == 0
                  ? 'text-left'
                  : i == milestones.length - 1
                  ? 'text-right'
                  : ''
              "
              style="padding-top: 0.4rem; width: 100%;"
              :style="{ 'font-weight': ms.is_checked ? 'bold' : '500' }"
            >
              {{ ms.text }}
            </div>
          </div>

          <!--          <div v-if="ms.show_popup"><mile-stone-popper :model="ms"></mile-stone-popper></div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import Popper from "@/components/popper";
import MilestoneDetailPopup from "@/components/milestone-detail-popup";
import "../assets/vue-popper.css";

export default {
  mixins: [globals],
  props: {
    model: Object
  },
  components: {
    popper: Popper,
    "mile-stone-popper": MilestoneDetailPopup
  },
  data() {
    return {
      show_popup: false,
      windowWidth: window.screen.width
    };
  },
  methods: {
    getOffset(el) {
      const rect = setTimeout(() => {
        el.getBoundingClientRect();
      }, 1000);
      return {
        left: rect.left,
        top: rect.bottom
      };
    },
    emitMileStone(ms) {
      this.toggleMileStoneModal(true, ms);
      this.$emit("msData", ms);
    }
  },

  computed: {
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    cssVars() {
      return {
        transform: `translate3d(30px,-200px,0) !important;`
      };
    }
  },
  created() {
    this.model.mile_stones = this.model.mile_stones;
    // this.formatUserCheckins(offer);
    // this.model.mile_stones = this.$store.state.user.mile_stones;
  },
  mounted() {}
};
</script>
<style>
.milestone-wrapper {
  white-space: nowrap;
  left: 0;
  right: 0;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
}
.milestone-wrapper .check-mark {
  display: inline-block;
  transform: rotate(45deg);
  width: 2px;
  height: 6px;
  border-bottom: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
}
</style>
